/* eslint-disable no-dupe-keys */
export default {
  admin_withdraw_application: {
    name: '管理员提现工单',
    // 属性（一般与对象内容匹配）
    prop: {
      serial_number: '编号',
      admin: '管理员',
      payee_name: '真实姓名',
      applied_amount: '提现金额',
      status: '状态',
      created_at: '申请时间',
      updated_at: '更新时间'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      serial_number: '编号',
      admin: '管理员',
      payee_name: '真实姓名',
      applied_amount: '提现金额',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    statuses: {
      pending: '待审核',
      passed: '已通过',
      transferred: '已转账',
      rejected: '已拒绝'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询编号/真实姓名'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    tips: {
      before_transferred: '提现的金额将通过微信转账'
    }
  }
}
